import React, { useEffect } from 'react';
import { FormikErrors, FormikValues, getIn, useFormikContext } from 'formik';
import { SelectField } from '@applications-terrains/birdz-react-library';
import Select from 'react-select';
import { Box } from '@mui/material';

interface SelectFieldWrapperProps {
  name: string;
  options?: {
    value: any;
    label: any;
  }[];
  label?: string;
  id?: string;
  selectedItems?: any[];
  isMulti?: boolean;
  style?: React.CSSProperties;
  sx?: React.CSSProperties;
  required?: boolean;
  disabled?: boolean;
  onChange?: (a: any, b: any) => void;
  errors?: FormikErrors<any>;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  simpleSelect?: boolean;
  value?: { label: string; value: number | string };
}

const SelectFieldWrapper: React.FC<SelectFieldWrapperProps> = (props: SelectFieldWrapperProps) => {
  const { values, setFieldValue } = useFormikContext();
  const errors = useFormikContext<FormikValues>().errors;
  const error = getIn(errors, props.name);

  useEffect(() => {
    if (!props.simpleSelect && values instanceof Object && !(props.name in values)) {
      setFieldValue(props.name, null);
    }
  }, [values, props.name, props.simpleSelect]);

  const errorColor = '#d32f2f'; // MUI error.main
  const errorShadow = '0 0 0 1px rgba(211, 47, 47, 1)'; // MUI-like focus shadow

  return props.simpleSelect ? (
    <>
      <Select
        {...props}
        value={
          props.value
            ? props.value
            : values instanceof Object && props.name in values
              ? props?.options?.find(
                  (option) => option.value === (values as FormikValues)[props.name]
                )
              : null
        }
        onChange={(option) => {
          const value = option ? option.value : null;
          setFieldValue(props.name, value);
        }}
        options={props.options}
        isClearable
        isMulti={false}
        menuPlacement="top"
        placeholder={props.label || 'Sélectionner...'}
        menuPortalTarget={document.body}
        styles={{
          control: (base, state) => {
            return {
              ...base,
              backgroundColor: 'transparent',
              borderColor: error ? errorColor : base.borderColor,
              boxShadow: state.isFocused ? (error ? errorShadow : base.boxShadow) : base.boxShadow,
              '&:hover': {
                borderColor: error ? errorColor : base.borderColor
              }
            };
          },
          input: (base) => ({
            ...base,
            backgroundColor: 'transparent',
            color: 'inherit'
          })
        }}
      />
      {typeof error === 'string' && (
        <Box
          style={{
            color: '#d32f2f',
            fontSize: '0.75rem',
            fontWeight: 400,
            paddingTop: '0.25rem',
            paddingLeft: '0.5rem'
          }}
        >
          {error}
        </Box>
      )}
    </>
  ) : (
    <SelectField {...props} />
  );
};

export default SelectFieldWrapper;
